
import { BscConnector } from '@binance-chain/bsc-connector'
import { NetworkConnector } from './bsc/NetworkConnector'
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'

//import { BscConnector } from './bscConnector'

const chainId = parseInt(process.env.REACT_APP_CHAIN_ID, 10)
const NETWORK_URL = process.env.REACT_APP_NETWORK_URL

  export const bsc = new BscConnector({
    supportedChainIds: [56, 97] // later on 1 ethereum mainnet and 3 ethereum ropsten will be supported
  })



export const injectedConnector = new InjectedConnector({
    supportedChainIds: [
      1, // Mainet
      3, // Ropsten
      4, // Rinkeby
      5, // Goerli
      42, // Kovan
      97, //bsc
      56  , // bsc test net
    ],
  })


  export const network = new NetworkConnector({
    urls: { [97]: "https://data-seed-prebsc-1-s1.binance.org:8545" },
  })

//   export const network = new NetworkConnector({
//    urls: { [56]: "https://bsc-dataseed1.defibit.io" },
//   })


export declare enum ChainId {
    MAINNET = 56,
    BSCTESTNET = 97
}

export const NetworkContextName  = "NETWORK"

// const rpcWallet = {  chainId : NETWORK_URL }
// const nodes = [ "https://bsc-dataseed1.ninicoin.io", "https://bsc-dataseed1.defibit.io", "https://bsc-dataseed.binance.org" ]
// const rpcUrl = nodes[2]

// mainnet only
export const walletconnect = new WalletConnectConnector({
  rpc: { [chainId]: NETWORK_URL },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  pollingInterval: 15000,
})
